const addActiveInSelections = (currMark, subMark, activeKey) => {
    if (typeof currMark === 'object' && typeof subMark === 'object') {
        if (currMark.selections && subMark.selections) {
            const selections = currMark.selections.map((selection, i) => {
                var _a, _b;
                return (Object.assign(Object.assign({}, selection), { [activeKey]: (_b = (_a = subMark.selections
                        .find(subselection => subselection.id === selection.id)) === null || _a === void 0 ? void 0 : _a[activeKey]) !== null && _b !== void 0 ? _b : selection[activeKey] }));
            });
            return Object.assign(Object.assign(Object.assign({}, currMark), subMark), { selections });
        }
        const currentKeys = Object.keys(currMark);
        return currentKeys.reduce((agg, key) => (Object.assign(Object.assign({}, agg), { [key]: addActiveInSelections(currMark[key], subMark[key], activeKey) })), {});
    }
    return currMark;
};
export const marketDataMatcher = (currentMarkets, subsMarkets) => {
    const activeKey = 'active';
    const copyCurrentMarkets = Object.assign({}, currentMarkets);
    const { byoMarketGroups: currentByoMarketGroups } = copyCurrentMarkets;
    const { byoMarketGroups: subByoMarketGroups } = subsMarkets;
    const marketsGroup = currentByoMarketGroups.map((currMarkEl) => {
        const subMarkEl = subByoMarketGroups.find(elem => elem.category === currMarkEl.category);
        if (subMarkEl) {
            const keysCurrMarket = Object.keys(currMarkEl === null || currMarkEl === void 0 ? void 0 : currMarkEl.markets);
            const updatedMarkets = keysCurrMarket.reduce((agg, marketKey) => {
                var _a, _b;
                const market = currMarkEl.markets[marketKey];
                const updateMarket = (_a = subMarkEl.markets) === null || _a === void 0 ? void 0 : _a[marketKey];
                return Object.assign(Object.assign({}, agg), { [marketKey]: updateMarket ? Object.assign(Object.assign(Object.assign({}, market), addActiveInSelections(market, updateMarket, activeKey)), { [activeKey]: (_b = updateMarket[activeKey]) !== null && _b !== void 0 ? _b : true }) : market });
            }, {});
            return Object.assign(Object.assign({}, currMarkEl), { markets: updatedMarkets });
        }
        return currMarkEl;
    });
    return Object.assign(Object.assign({}, copyCurrentMarkets), { byoMarketGroups: marketsGroup });
};
